import Image from 'next/image'
import { tm } from '@captaincause/ui/tm'
import { YoutubeIframe } from '@captaincause/ui/YoutubeIframe'
import { Button } from 'components/Button'
import type { LocalImage } from 'types/strapi/image'
import type { StrapiLink } from 'types/strapi/link'

export interface VideoProps {
  title: string | null
  youtubeId: string
  image?: LocalImage | null
  primaryLink?: (StrapiLink & { locale?: false | undefined }) | null
  secondaryLink?: (StrapiLink & { locale?: false | undefined }) | null
}

export default function Video({
  title,
  youtubeId,
  image = null,
  primaryLink = null,
  secondaryLink = null,
}: VideoProps) {
  return (
    <div className="h-auto overflow-hidden bg-black">
      <div className="relative mx-auto max-w-[1400px] px-4 py-12 text-white md:px-8 md:py-20">
        <div className="mb-8 flex w-full flex-col items-center justify-between md:mb-14 md:flex-row">
          <div className="flex w-full flex-col items-center justify-center space-y-1">
            <h2 className="mt-4 flex-1 text-center text-3xl md:mt-0">
              {title}
            </h2>
            {image ? (
              <Image
                src={image.image.src}
                alt={image.alt}
                height={48}
                width={356}
                className="h-[48px] w-[356px]"
              />
            ) : null}
          </div>
        </div>
        <div>
          <YoutubeIframe
            id={youtubeId}
            variant="large"
            className="lg:h-[500px]"
          />
        </div>
        {primaryLink || secondaryLink ? (
          <div className="mt-10 flex flex-col items-center justify-center gap-4 md:flex-row md:gap-x-8">
            {primaryLink ? (
              <Button
                href={primaryLink.url}
                locale={false}
                className="rounded-[40px] bg-white px-7 py-3 text-black hover:bg-white/80 focus-visible:bg-white/80"
              >
                {primaryLink.title}
              </Button>
            ) : null}
            {secondaryLink ? (
              <Button
                href={secondaryLink.url}
                locale={false}
                className="rounded-[40px] border border-white bg-black px-7 py-3 text-white"
              >
                {secondaryLink.title}
              </Button>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  )
}
